// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__ePR1x","footer":"ModalInfo_footer__2BwKJ"};